import { render, staticRenderFns } from "./SubpageList.vue?vue&type=template&id=5cd72ed1"
import script from "./SubpageList.vue?vue&type=script&lang=js"
export * from "./SubpageList.vue?vue&type=script&lang=js"
import style0 from "./SubpageList.vue?vue&type=style&index=0&id=5cd72ed1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports